/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import { User } from "@auth0/auth0-spa-js";
import { datadogLogs } from "@datadog/browser-logs";
import { useCustomer } from "~/context";
import { useDatadogRUM } from "~/services/datadog/useDatadogRum";
import { isNotNil } from "~/tools";

type Customer = ReturnType<typeof useCustomer>["customer"];

type UserData =
  | (User & {
      customer?: Customer;
    })
  | undefined;

export function useSetupUserTracking(userData: UserData) {
  useSetupDatadogUser(userData);
}

function useSetupDatadogUser(userData: UserData) {
  const ddRum = useDatadogRUM();

  useEffect(() => {
    if (isNotNil(ddRum) && isNotNil(userData)) {
      ddRum.setUser({
        id: userData.email,
        email: userData.email,
        customerId: userData.customer?.id,
        customer: userData.customer?.name,
      });
      datadogLogs.setUser({
        id: userData.email,
        email: userData.email,
        customerId: userData.customer?.id,
        customer: userData.customer?.name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `userData?.email` and `userData.customer.id` assert uniqueness
  }, [ddRum, userData?.email, userData?.customer?.id]);
}
